import React from "react";
import { Trash2 } from "lucide-react";
import PageHeader from "components/ui/PageHeader";

interface TrashHeaderProps {
  hasItems?: boolean;
  itemCount?: number;
}

const TrashHeader: React.FC<TrashHeaderProps> = ({ hasItems, itemCount }) => (
  <PageHeader
    icon={<Trash2 className="w-5 h-5" />}
    iconBg="bg-red-50 dark:bg-red-900/20"
    iconColor="text-red-500 dark:text-red-400"
    accentColor="bg-gradient-to-r from-red-400 to-rose-500"
    title="Trash"
    subtitle={
      hasItems && itemCount
        ? `${itemCount} item${itemCount !== 1 ? "s" : ""} waiting — permanently removed after 30 days`
        : "Deleted items are held for 30 days before permanent removal"
    }
  />
);

export default TrashHeader;
